import { Nilable } from "@shared/utils";
import { DTO, IDTO } from "./dto";

export interface ICodigoValorDTO extends IDTO {
    dollar_amount: Nilable<number>;
    percentage: Nilable<number>;
}

export class CodigoValorDTO implements DTO {
    public cantidadDolares: Nilable<number>;
    public porcentaje: Nilable<number>;

    constructor(json: Nilable<ICodigoValorDTO> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: ICodigoValorDTO) {
        if (json.dollar_amount != null) {
            this.cantidadDolares = json.dollar_amount;
        }
        if (json.percentage != null) {
            this.porcentaje = json.percentage;
        }
    }

    public toJSON(): ICodigoValorDTO {
        return {
            dollar_amount: this.cantidadDolares,
            percentage: this.porcentaje
        };
    }

}
